import React from 'react';
import { CardInvalide } from '../Cards';

const PageInscriptionKo = () => (
    <CardInvalide Lien="/Inscription">
        <p>Un problème est survenu lors de la validation de votre compte.</p>
        <p>Vérifiez que votre compte ne soit pas déjà validé.</p>
        <p>Si ce n&apos;est pas le cas, recommencez la procédure.</p>
    </CardInvalide>
);

export default PageInscriptionKo;



// WEBPACK FOOTER //
// ./src/components/Adherent/Inscription/PageInscriptionKo.js